<template>
  <svg :width="width" :height="height" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M1.79289 7.29289C1.40237 7.68342 1.40237 8.31658 1.79289 8.70711L11.2929 18.2071C11.6834 18.5976 12.3166 18.5976 12.7071 18.2071L22.2071 8.70711C22.5976 8.31658 22.5976 7.68342 22.2071 7.29289C21.8166 6.90237 21.1834 6.90237 20.7929 7.29289L12 16.0858L3.20711 7.29289C2.81658 6.90237 2.18342 6.90237 1.79289 7.29289Z"
      :fill="color"
    />
  </svg>
</template>

<script lang="ts">
export default {
  name: 'ExpandIcon',
  props: {
    width: {
      type: Number,
      default: 24,
    },
    height: {
      type: Number,
      default: 24,
    },
    color: {
      type: String,
      default: '#99005c',
    },
  },
};
</script>
